import Vue from 'vue'
import { DatePicker } from 'v-calendar'

Vue.component('VDatePicker', DatePicker)
